export const CREATE_RETURN5216 = "CREATE_RETURN5216";
export const UPDATE_RETURN5216 = "UPDATE_RETURN5216";
export const DELETE_RETURN5216 = "DELETE_RETURN5216";
export const FETCH_RETURN5216 = "FETCH_RETURN5216";
export const LISTEN_TO_SELECTED_RETURN5216 = "LISTEN_TO_SELECTED_RETURN5216";
export const FILTER_RETURN5216 = "FILTER_RETURN5216";
